/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import TextContainer from "../../Container/TextContainer";
import Typography from "@mui/material/Typography";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";

const Benefits = () => {
  return (
    <TextContainer sx={jobStyles.container}>
      <Typography variant={"h4"}>Was wir Dir bieten und was uns auszeichnet</Typography>
      <MuiListNativeStyled
        sx={jobStyles.list}
        listItems={[
          "Eine unternehmerische und anspruchsvolle Arbeit in einem hochmotivierten Team, in dem Du Deine Karriere auf das nächste Level bringen kannst – persönliche und berufliche Weiterentwicklungsmöglichkeiten inklusive",
          "Die Chance, in einem stark wachsenden Unternehmen dabei zu sein, viel zu lernen und Verantwortung zu übernehmen",
          "Wir bieten Dir flexible Arbeitszeiten und Homeoffice an, denn Du entscheidest wie und wann Du Deine beste Leistung erbringst.",
          "Eine tolle Arbeitsatmosphäre in einem modernen Büro inkl. Außenterrasse mit einem phantastischen Blick auf den Rhein und sehr guter Erreichbarkeit mit öffentlichen Verkehrsmitteln",
          "Alle Klassiker, wie Obstkorb, Deutschlandticket und Zuschuss zum Urban Sports Club sind natürlich auch dabei",
        ]}
      />
    </TextContainer>
  );
};

export default Benefits;
